import React from 'react'
import ReactDOM from 'react-dom'
import 'styles/index.scss'
import App from 'app'
import { Provider } from 'react-redux'
import store from 'redux/store'
import * as serviceWorkerRegistration from 'serviceWorkerRegistration'
import ErrorBoundary from 'pages/_errorBoundary'

ReactDOM.render(
    <ErrorBoundary>
        <Provider store={store}>
            <App />
        </Provider>
    </ErrorBoundary>,
    document.getElementById('root'),
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister()
